import { useState } from "react";
import { format } from "date-fns";
import { it } from "date-fns/locale";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Calendar as CalIcon } from "lucide-react";

function toDate(iso) {
  if (!iso) return undefined;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}
function toIso(date) {
  if (!date) return "";
  return format(date, "yyyy-MM-dd");
}

export default function DatePicker({ value, onChange, placeholder = "gg/mm/aaaa", testid }) {
  const [open, setOpen] = useState(false);
  const date = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testid} type="button"
          className="flex items-center gap-2 border border-stone-300 bg-white px-3 py-1.5 text-sm rounded-sm outline-none hover:bg-stone-50 focus:ring-2 focus:ring-brand/40 transition-colors min-w-[132px]">
          <CalIcon size={14} className="text-stone-400" strokeWidth={1.5} />
          <span className={date ? "text-stone-800" : "text-stone-400"}>
            {date ? format(date, "dd/MM/yyyy", { locale: it }) : placeholder}
          </span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-sm" align="start">
        <Calendar mode="single" selected={date} locale={it} initialFocus
          onSelect={(d) => { onChange(toIso(d)); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
}
